import DTCsCard from "./DTCsCard"

export default  DTCsCard;
